import { __rest } from 'tslib';
import { InjectorService, ProviderRegistry } from '@tencent/ioc';
import { FeatureService } from '../../services/feature/feature-service.js';
import { FeatureRegistry } from '../../registries/feature-registry.js';

/**
 * Feature 装饰器，用于声明一个新的 Feature，注入到其它 Feature 的 `constructor` 中。
 * 所有用 `@Feature()` 注解的类均在同一时间被初始化
 *
 * @remarks
 * ### Example
 *
 * ```typescript
 * import { Feature, Workbench } from '@tencent/workbench';
 * import OtherFeature from './other_feature';
 *
 * @Feature()
 * class MyFeature {
 *   constructor(private otherFeature: OtherFeature) {}
 * }
 *
 * const workbench = new Workbench();
 * workbench.mount([MyFeature, OtherFeature]); // 此时初始化
 * ```
 *
 * @param options - Feature 选项
 * @public
 * @decorator
 */
function Feature(options = {}) {
    return (target) => {
        target.prototype.toString = () => { var _a; return (_a = options.name) !== null && _a !== void 0 ? _a : target.name; };
        target.displayName = options.name;
        const { provide } = options, rest = __rest(options, ["provide"]);
        FeatureRegistry.merge(target, options);
        if (provide) {
            InjectorService.service(provide, target, Object.assign(Object.assign({}, rest), { type: 'feature' }));
        }
        else {
            InjectorService.service(target, Object.assign(Object.assign({}, rest), { type: 'feature' }));
        }
        InjectorService.invokable(target);
        InjectorService.addPostConstructor(provide !== null && provide !== void 0 ? provide : target, (instance) => {
            var _a;
            const featureService = InjectorService.get(FeatureService);
            const provider = ProviderRegistry.get(target);
            if (provider) {
                provider.instance = instance;
                featureService.mount([(_a = options.provide) !== null && _a !== void 0 ? _a : target]);
            }
        });
        return target;
    };
}

export { Feature };
//# sourceMappingURL=feature.js.map
